import React from "react";
import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AddProgrammeModal from "../Modals/AddProgrammeModal";
import { ProgrammeList } from "../Modals/ProgrammeList";
import { MdAddBox } from "react-icons/md";
export const SingleProgrammeList = ({ props, id, func }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const [modal, setModal] = useState("");
  const { full_name, city, programs } = props;
  return (
    <tr>
      <td>{full_name}</td>
      <td>{city}</td>
      <td
        className="pointer"
        onClick={() => {
          setModal("addProgramme");
          onOpen();
        }}
        style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
      >
        <MdAddBox size={20} /> Attendance
      </td>
      <td
        className="pointer"
        onClick={() => {
          setModal("programmeList");
          onOpen();
        }}
      >
        See All Attendance
      </td>

      {modal === "programmeList" && (
        <ProgrammeList isOpen={isOpen} onClose={onClose} data={programs} id={id} func={func}/>
      )}

      {modal === "addProgramme" && (
        <AddProgrammeModal
          isOpen={isOpen}
          onClose={onClose}
          id={id}
          func={func}
        />
      )}
    </tr>
  );
};
